import type {UsersSearch} from "./list-users.schema";

import {keepPreviousData, useQuery} from "@tanstack/react-query";

import {listUsersQueryOptions} from "./list-users.query-options";

/**
 * Query hook: Fetch users list with pagination, search, sort, filter.
 * Uses useQuery with keepPreviousData to allow smooth transitions during pagination.
 *
 * @param search - List parameters (page, perPage, search, sort, filter)
 * @returns Query result with paginated users data
 *
 * @example
 * const { data, isFetching } = useListUsers({ page: 1, perPage: 20, q: "alice" });
 */
export function useListUsers(search: Partial<UsersSearch>) {
  return useQuery({
    ...listUsersQueryOptions(search),
    placeholderData: keepPreviousData,
  });
}
